export const FAQS = 'faqs'
